/** @jsxImportSource theme-ui */
import { ThemeUIStyleObject } from 'theme-ui';

export const dashboardPageStyles: Record<string, ThemeUIStyleObject> = {
  // Custom container styling - specific layout not available via component props
  container: {
    bg: 'background.subtle',
    p: 0,
    display: 'flex',
    flexDirection: 'column',
  },

  // Custom loading container - specialized centered layout with specific styling
  loadingContainer: {
    p: '0.5rem',
    textAlign: 'center',
    minHeight: `calc(100vh - 4rem)`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.25rem',
    bg: 'neutral/100',
  },

  // Custom error container - specialized centered layout for error states
  errorContainer: {
    p: '0.5rem',
    textAlign: 'center',
    minHeight: `calc(100vh - 4rem)`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    bg: 'neutral/100',
  },

  // Custom content area - specific max-width and layout constraints
  contentArea: {
    maxWidth: '1200px',
    mx: 'auto',
    p: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },

  // Custom content box - card-like styling for main content
  contentBox: {
    p: '0.5rem',
    bg: 'background',
    borderRadius: 'default',
    boxShadow: 'small',
    border: '1px solid',
    borderColor: 'neutral/300',
  },

  // Simple spacing utilities for content sections
  heading: {
    mb: '0.25rem',
  },

  welcomeText: {
    mb: '0.25rem',
  },

  subText: {
    mb: '0.25rem',
  },
};
